import { Timer, User } from "~/types"

export const showTimerEndedNotification = (timer?: Timer | null) => {
  new Notification("Pomodoro", {
    body: timer?.break ? "Pomodoro break ended" : "Pomodoro timer ended",
    icon: timer?.break ? "/favicon-break.png" : "/favicon.png",
  })
}

export const showParticipantJoinedNotification = (
  user: User,
  timer?: Timer | null,
) => {
  const icon =
    (user.picture ?? timer?.break) ? "/favicon-break.png" : "/favicon.png"
  new Notification("Pomodoro", {
    body: `${user.name} entered pomodoro space`,
    icon,
  })
}

export const showParticipantLeftNotification = (
  user: User,
  timer?: Timer | null,
) => {
  const icon =
    (user.picture ?? timer?.break) ? "/favicon-break.png" : "/favicon.png"
  new Notification("Pomodoro", {
    body: `${user.name} left pomodoro space`,
    icon,
  })
}
